<script lang="ts">
import { computed, defineComponent } from "vue";

export default defineComponent({
  name: "ProduktKarte",
  components: {},
  props: {
    produkt: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const base = "https://www.gev-versicherung.de/";
    const bildBase = base + "typo3conf/ext/gev_site_package/Resources/Public/Images/card/";

    const versicherungen: { [key: string]: any } = {
      vgv: {
        produktName: "Wohngebäudeversicherung",
        link: "versicherungen/wohngebaeudeversicherung/",
        rechnerLink: "versicherungen/wohngebaeudeversicherung/rechner/",
        bild: "wohngebaeude/wg_card_900x800.jpg",
        preis: "ab 4,85 € mtl.",
      },
      hr: {
        produktName: "Hausratversicherung",
        link: "versicherungen/hausratversicherung/",
        rechnerLink: "versicherungen/hausratversicherung/rechner/",
        bild: "hausrat/hr_card_900x800.jpg",
        preis: "ab 2,90 € mtl.",
      },
      fhv: {
        produktName: "Ferienhausversicherung",
        link: "versicherungen/ferienhausversicherung/",
        rechnerLink: "versicherungen/ferienhausversicherung/rechner/",
        bild: "ferienhauskonzept/fhk_card_900x800.jpg",
      },
      phv: {
        produktName: "Privathaftpflichtversicherung",
        link: "versicherungen/privathaftpflicht/",
        rechnerLink: "versicherungen/privathaftpflicht/rechner/",
        bild: "phv/phv_card_900x800.jpg",
        preis: "ab 1,98 € mtl.",
      },
      hug: {
        produktName: "Haus- und Grundbesitzerhaftpflicht",
        link: "versicherungen/haus-und-grundbesitzerhaftpflicht/",
        rechnerLink: "versicherungen/haus-und-grundbesitzerhaftpflicht/rechner/",
        bild: "hug/hug_card_900x800.jpg",
        preis: "ab 2,37 € mtl.",
      },
      bhh: {
        produktName: "Bauherrenhaftpflichtversicherung",
        link: "versicherungen/bauherrenhaftpflicht/",
        rechnerLink: "versicherungen/bauherrenhaftpflicht/rechner/",
        bild: "bauherren/bhh_card_900x800.jpg",
        preis: "ab 35,16 € Einmalbetrag",
      },
      bl: {
        produktName: "Bauleistungsversicherung",
        link: "versicherungen/bauleistungsversicherung/",
        rechnerLink: "versicherungen/bauleistungsversicherung/rechner/",
        bild: "bauleistung/bl_card_900x800.jpg",
        preis: "ab 160,00 € Einmalbetrag",
      },
      ghv: {
        produktName: "Gewässerschadenhaftpflicht",
        link: "versicherungen/gewaesserschadenhaftpflicht/",
        rechnerLink: "versicherungen/gewaesserschadenhaftpflicht/rechner/",
        bild: "gewaesserschaden/gew_card_900x800.jpg",
        preis: "ab 4,10 € mtl.",
      },
    };

    const produktName = computed(() => {
      return versicherungen[props.produkt].produktName;
    });

    const link = computed(() => {
      return base + versicherungen[props.produkt].link;
    });

    const rechnerLink = computed(() => {
      return base + versicherungen[props.produkt].rechnerLink;
    });

    const mehrAltText = computed(() => {
      return "Mehr zur " + versicherungen[props.produkt].produktName + " erfahren";
    });

    const berechnenAltText = computed(() => {
      return versicherungen[props.produkt].produktName + " berechnen";
    });

    const bildLink = computed(() => {
      return bildBase + versicherungen[props.produkt].bild;
    });

    const bildSrc = computed(() => {
      return bildBase + versicherungen[props.produkt].bild + " 1x";
    });

    const preis = computed(() => {
      return versicherungen[props.produkt].preis;
    });

    return {
      props,
      produktName,
      mehrAltText,
      berechnenAltText,
      link,
      rechnerLink,
      bildLink,
      bildSrc,
      preis,
    };
  },
});
</script>

<template>
  <div class="o-grid__cell o-grid__cell--6-768 o-grid__cell--4-1024">
    <div class="c-card c-card--fixed-width">
      <div class="c-card__image-container">
        <a :href="link" class="inherited" :title="produktName" target="_self">
          <picture>
            <source media="(max-width: 767px)" :srcset="bildSrc" />
            <source media="(max-width: 1023px)" :srcset="bildSrc" />
            <source media="(min-width: 1024px)" :srcset="bildSrc" />
            <img class="c-card__image" :src="bildLink" :alt="produktName" />
          </picture>
          <span v-if="preis" class="c-card__badge">{{ preis }}</span>
        </a>
      </div>
      <div class="c-card__content-container">
        <div class="c-card__content-wrapper">
          <h4 class="c-card__heading">
            <a :href="link" class="inherited" :title="produktName" target="_self">{{ produktName.toUpperCase() }}</a>
          </h4>
          <p class="c-card__text">
            <a :href="link" class="inherited" :title="produktName" target="_self"
              >Die ganz nach eigenen Bedürfnissen zusammenstellbare Absicherung trägt die Kosten für Reparaturen oder
              sogar den Wiederaufbau Ihres Gebäudes...</a
            >
          </p>
        </div>
        <div class="u-mar-t-0">
          <div class="c-card__controls-item">
            <div class="o-grid o-grid--align-middle o-grid--no-y-gutter">
              <div class="o-grid__cell c-card__more">
                <a :href="link" :title="mehrAltText" target="_self">Mehr Infos</a>
              </div>
              <div class="o-grid__cell u-text-align-right">
                <a :href="rechnerLink" role="button" class="c-button" :title="berechnenAltText" target="_self"
                  >Jetzt berechnen</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.c-card__heading {
  a {
    color: #599F7C;
    text-decoration: none;
  }

  a:active {
    color: #288dce;
  }

  a:hover {
    color: #2375aa;
  }
}

.c-card__text {
  a {
    color: #333;
    text-decoration: none;
    font-weight: 400;
  }

  a:hover {
    color: #2375aa;
  }
}

.c-card__more {
  a {
    color: #0f5582;
  }

  a:active {
    color: #288dce;
  }

  a:hover {
    color: #2375aa;
  }
}
</style>
